import { Button } from '@kcftech/design-system';
import styled, { css } from 'styled-components';
import { tokens } from 'styles/tokens';

/**
 * Rounded DSM Button
 * TODO: Decide what is primary, secondary, tertiary
 */
export const StyledButton = styled(Button)<{
    $padding?: string;
    $color?: string;
    $background?: string;
    $hoverBackground?: string;
    $border?: string;
}>`
    white-space: nowrap;
    display: flex !important;
    justify-content: center !important;
    border-radius: 5px !important;
    padding: ${({ $padding }) => ($padding ? `${$padding} !important` : undefined)};
    color: ${({ $color }) => ($color ? `${$color} !important` : undefined)};
    background: ${({ $background }) =>
        $background ? `${$background} !important` : undefined};
    border: ${({ $border }) => ($border ? `${$border} !important` : undefined)};

    /* Ensure SVG icons follow button's color and don't have separate hover */
    & svg {
        color: inherit;
        fill: currentColor;
        transition: none;
    }

    &:disabled {
        color: ${tokens.action.disabled} !important;
        background: ${tokens.action.disabledBackground} !important;
    }

    ${({ $hoverBackground }) =>
        $hoverBackground
            ? css`
                  &:hover:not(:disabled) {
                      background: ${$hoverBackground} !important;
                  }
              `
            : undefined};
`;
